export default class MosaicItemText {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.mosaic-item-text'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {String} */
	#currentFeatureIconElement;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		if (!document.querySelector('h1')) {
			let content = this.#holderElement.querySelector('.content');
			let h1 = document.createElement('h1');
			h1.innerHTML = content.querySelector('h4').innerHTML;
			content.replaceChild(h1, content.querySelector('h4'));
		}

		this.onload();
	}

	onload() {
		if (this.#holderElement.classList.contains('hide-on-desktop')) {
			if (this.#holderElement.closest('.outer-col').querySelectorAll('.inner-row').length > 1) {
				this.#holderElement.closest('.inner-row').classList.add('hide-on-desktop');
			} else {
				this.#holderElement.closest('.outer-col').classList.add('hide-on-desktop');
			}
		}
		if (this.#holderElement.classList.contains('hide-on-mobile')) {
			if (this.#holderElement.closest('.outer-col').querySelectorAll('.inner-row').length > 1) {
				this.#holderElement.closest('.inner-row').classList.add('hide-on-mobile');
			} else {
				this.#holderElement.closest('.outer-col').classList.add('hide-on-mobile');
			}
		}

		this.#setActiveFeature();
	}

	#setActiveFeature() {
		let firstFeatureItem = this.#holderElement.querySelectorAll('.feature-item') ? this.#holderElement.querySelectorAll('.feature-item')[0] : null;
		this.#currentFeatureIconElement = '<img src="' + window.config.themeDirectory + '/images/svg/arrow-left-dark.svg" alt="Current feature" class="current-feature-icon">';
		if (firstFeatureItem) {
			// firstFeatureItem.insertAdjacentHTML('beforebegin', this.#currentFeatureIconElement);
			firstFeatureItem.innerHTML = this.#currentFeatureIconElement + firstFeatureItem.innerHTML;
			firstFeatureItem.classList.add('active');
		}
		this.#holderElement.querySelectorAll('.feature-item').forEach((featureItem) => {
			if (!featureItem.classList.contains('active')) {
				featureItem.classList.add('collapsed');
			}
			featureItem.addEventListener('click', (event) => {
				this.#holderElement.querySelector('.current-feature-icon').remove();
				// featureItem.insertAdjacentHTML('beforebegin', this.#currentFeatureIconElement);
				featureItem.innerHTML = this.#currentFeatureIconElement + featureItem.innerHTML;

				this.#holderElement.querySelectorAll('.feature-item').forEach((item) => {
					if (item !== featureItem) {
						item.classList.remove('active');
					}
				});
				featureItem.classList.add('active');

				for (const contentItem of this.#holderElement.querySelectorAll('.collapse')) {
					contentItem.classList.remove('show');
				}
			});
		});
	}
}
